import axios from "../../axios";
import { dateStart, dateEnd } from "../../utils/util";

const schedulePickup = async ({ dataPacket }) => {
  try {
    console.log(dataPacket, "dataPacket");
    const { data } = await axios.post(`/service_tickets/schedule_pickup`, {...dataPacket});
    return data;
  } catch (e) {
    return null;
  }
};

const getScheduledPickups = async (from) => {
  from = from ? `?[ignore][from]=${from}` : '';
  try {
    const { data } = await axios.get(`/service_tickets/pickups${from}`);
    return data;
  } catch (e) {
    return [];
  }
};

const getDailyPickups = async (date) => {
  console.log(date, "date******");
  try {
    const { data } = await axios.get(`/service_tickets/pickups/daily?date=${date}`);
    return data;
  } catch (e) {
    return [];
  }
};

const getAppointmentsByCustomer = async (customer_id, appointment_id) => {
  let appt = appointment_id ? `&appointment_id[$eq]=${appointment_id}` : '';
  try {
    const { data } = await axios.get(`/appointments/customer/${customer_id}/active?status[$eq]=scheduled${appt}`);
    console.log(data, "appointments");
    return data;
  } catch (e) {
    return null;
  }
};

const getTicketsByAppointment = async (appointment_id) => {
  try {
    const { data } = await axios.get(`/service_tickets/appointment/${appointment_id}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const getScheduledTickets = async (period) => {
  let today = new Date();
  let startDate = dateStart(today);
  let endDate = dateEnd(today);

  let periodLimit = period === "today" ? `&scheduled_check_in_at[$lte]=${endDate}` : `&scheduled_check_in_at[$gte]=${endDate}`;

  // console.log(startDate, endDate);
  try {
    // const { data } = await axios.get(`/service_tickets?status[$in]=scheduled,checked_in,prepping,in_progress&scheduled_check_in_at[$gte]=${startDate}&scheduled_check_in_at[$lte]=${endDate}`);
    const { data } = await axios.get(`/service_tickets?sort=scheduled_date&status[$in]=scheduled${periodLimit}&prep_time[$gt]=0`);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const getTicketById = async (id) => {
  try {
    const { data } = await axios.get(`/service_tickets/${id}`);
    return data;
  } catch (e) {
    return null;
  }
}

const checkInWig = async ({wig_id, notes, service_ticket_id}) => {
  try {
    const { data } = await axios.put(`/service_tickets/check_in/${service_ticket_id}`, {wig_id, notes});
    return data;
  } catch (e) {
    return null;
  }
}

const checkOutWig = async ({service_ticket_id}) => {
  try {
    const { data } = await axios.put(`/service_tickets/check_out/${service_ticket_id}`, {status: "scheduled"});
    return data;
  } catch (e) {
    return null;
  }
}

const searchTickets = async (search) => {
  let searchTerm = search ? `&term[search]=${search}` : '';
  try {
    const { data } = await axios.get(`/service_tickets?sort=scheduled_date&status[$in]=checked_in,prepping,prep_done,in_progress${searchTerm}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getStations = async () => {
  try {
    const { data } = await axios.get(`/services/stations?station_type[$eq]=service`);
    return data;
  } catch (e) {
    return null;
  }
}

const updateStage = async ({service_ticket_id, step = "proceed"}) => {
  try {
    const { data } = await axios.put(`/service_tickets/stages/${service_ticket_id}?step=${step}`, {});
    return data;
  } catch (e) {
    return null;
  }
}

const modifyStages = ({service_ticket_id, prep_stages}) => {
  try {
    const { data } = axios.put(`/service_tickets/modify-stages/${service_ticket_id}`, {prep_stages});
    return data;
  } catch (e) {
    return null;
  }
}

const saveStationView = async (list) => {
  try {
    let dataPacket = {
      resource: "stations",
      resource_tab: "station_view",
      settings_level: "user",
      data: list
    }

    let { data } = await axios.post(`/settings`, dataPacket);
    return data;
  } catch (e) {
    return null;
  }
}

const getStationView = async () => {
  try {
    let { data } = await axios.get(`/settings/stations/station_view`);
    return data;
  } catch (e) {
    return null;
  }
}

const deleteServiceTicket = async (id) => {
  try {
    const { data } = await axios.delete(`/service_tickets/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
}


export { schedulePickup, getScheduledPickups, getAppointmentsByCustomer, searchTickets, getScheduledTickets, getTicketById, checkInWig, checkOutWig, getStations, updateStage, modifyStages, getTicketsByAppointment, saveStationView, getStationView, getDailyPickups, deleteServiceTicket };
